import { Toaster } from "@/components/ui/sonner";
import { TooltipProvider } from "@/components/ui/tooltip";
import NotFound from "@/pages/NotFound";
import { Route, Switch } from "wouter";
import ErrorBoundary from "./components/ErrorBoundary";
import { ThemeProvider } from "./contexts/ThemeContext";
import Home from "./pages/Home";
import AdminDashboard from "./pages/AdminDashboard";
import RepDashboard from "./pages/RepDashboard";
import LandingPage from "./pages/LandingPage";
import GHLGuide from "./pages/GHLGuide";
import TeamMemberDashboard from "./pages/TeamMemberDashboard";
import ClientPortal from "./pages/ClientPortal";
import AgentRegistrationGuide from "./pages/AgentRegistrationGuide";
import JoinAgent from "./pages/JoinAgent";
import AssociateLanding from "./pages/AssociateLanding";
import AgentVerifyPortal from "./pages/AgentVerifyPortal";
import Scale360Checkout from "./pages/Scale360Checkout";
import Scale360CheckoutReturn from "./pages/Scale360CheckoutReturn";
import Scale360Success from "./pages/Scale360Success";
import Fundable360Checkout from "./pages/Fundable360Checkout";
import Fundable360CheckoutReturn from "./pages/Fundable360CheckoutReturn";
import VoiceCommandCenter from "./pages/VoiceCommandCenter";
import WibizInternalAiCosts from "./pages/WibizInternalAiCosts";
import AgreementSigning from "./pages/AgreementSigning";

function Router() {
  return (
    <Switch>
      <Route path="/" component={Home} />
      <Route path="/admin" component={AdminDashboard} />
      <Route path="/rep" component={RepDashboard} />
      <Route path="/rep/:repCode" component={RepDashboard} />
      <Route path="/join" component={LandingPage} />
      <Route path="/ghl-guide" component={GHLGuide} />
      <Route path="/team" component={TeamMemberDashboard} />
      <Route path="/client-portal" component={ClientPortal} />
      <Route path="/agent-registration-guide" component={AgentRegistrationGuide} />
      <Route path="/join-agent" component={JoinAgent} />
      <Route path="/associates" component={AssociateLanding} />
      <Route path="/agent-verify" component={AgentVerifyPortal} />
      <Route path="/scale360/checkout" component={Scale360Checkout} />
      <Route path="/scale360/checkout/return" component={Scale360CheckoutReturn} />
      <Route path="/scale360/success" component={Scale360Success} />
      <Route path="/fundable360/checkout" component={Fundable360Checkout} />
      <Route path="/fundable360/checkout/return" component={Fundable360CheckoutReturn} />
      <Route path="/voice-center" component={VoiceCommandCenter} />
      <Route path="/wibiz-internal/ai-costs" component={WibizInternalAiCosts} />
      <Route path="/agreements/sign/:requestId" component={AgreementSigning} />
      <Route path="/404" component={NotFound} />
      <Route component={NotFound} />
    </Switch>
  );
}

function App() {
  return (
    <ErrorBoundary>
      <ThemeProvider defaultTheme="light">
        <TooltipProvider>
          <Toaster />
          <Router />
        </TooltipProvider>
      </ThemeProvider>
    </ErrorBoundary>
  );
}

export default App;
